import { CompositeItem } from '@floating-ui/react';
import classNames from 'classnames';
import { forwardRef, type ReactElement } from 'react';
import type { StrateItemProps } from './StrateItem.types';

/**
 * `StrateItem` is a component used as a child of the Strate component.
 * It renders a <li> element and is styled to work with the Strate component.
 *
 * @example
 * <StrateItem>
 *   <Media aspectRatio="169" image={<MediaImage src={imageSrc} sources={imageSources} />} />
 * </StrateItem>
 */
export const StrateItem = forwardRef<HTMLLIElement, StrateItemProps>(
  function StrateItem({ className, composite, children, ...props }, ref) {
    return (
      <li
        ref={ref}
        className={classNames('inline-block', className)}
        {...props}
      >
        {composite ? (
          <CompositeItem render={children as ReactElement} />
        ) : (
          children
        )}
      </li>
    );
  },
);
